// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBnAKA5bsLaTosvHLsZjScraNi6MHicCe8",
    authDomain: "souls-cf239.firebaseapp.com",
    databaseURL: "https://souls-cf239.firebaseio.com",
    projectId: "souls-cf239",
    storageBucket: "souls-cf239.appspot.com",
    messagingSenderId: "909863839794",
    appId: "1:909863839794:web:64f74411e2f8889992f42b",
    measurementId: "G-327YMPDPWQ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
